import { Button } from '@billy/design-system'
import React from 'react'

import * as Styled from './styles'

interface ToggleVisibilityWidgetButtonProps {
  handleClick: () => void
}

export const ToggleVisibilityWidgetButton = ({ handleClick }: ToggleVisibilityWidgetButtonProps) => {
  return (
    <Styled.ToggleVisibilityWidgetButtonContainer>
      <Button
        icon="eyeOff"
        onClick={handleClick}
        size="md"
        variant="outlined"
        data-testid="toggle-visibility-widget-button"
      />
    </Styled.ToggleVisibilityWidgetButtonContainer>
  )
}
